import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ChatCircleDots, ArrowLeft } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Berhasil masuk!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Gagal masuk");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 font-bold mb-6" data-testid="login-back-link">
          <ArrowLeft size={18} weight="bold" /> Kembali
        </Link>
        <div className="nb-card nb-card-lg p-8">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-10 h-10 bg-[#A7E4C0] border-2 border-[#121212] rounded-lg flex items-center justify-center">
              <ChatCircleDots size={22} weight="bold" />
            </div>
            <span className="font-display font-black text-2xl">Layanan lainnya RS Mulya</span>
          </div>
          <h1 className="font-display font-black text-3xl tracking-tight">Masuk akun</h1>
          <p className="text-[#4A4A4A] mt-1">Kelola formulir & menu WhatsApp Anda.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="nb-label">Email</label>
              <input
                type="email"
                required
                className="nb-input"
                placeholder="nama@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="nb-label">Password</label>
              <input
                type="password"
                required
                className="nb-input"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
              />
            </div>
            <button type="submit" disabled={busy} className="nb-btn nb-btn-primary w-full justify-center" data-testid="login-submit-button">
              {busy ? "Memproses…" : "Masuk"}
            </button>
          </form>

          <p className="text-sm text-center mt-6 text-[#4A4A4A]">
            Belum punya akun?{" "}
            <Link to="/register" className="font-bold underline" data-testid="login-register-link">Daftar gratis</Link>
          </p>

          <div className="mt-5 p-3 bg-[#FFD166]/40 border-2 border-[#121212] rounded-lg" data-testid="demo-credentials-hint">
            <p className="text-xs font-bold uppercase tracking-widest">Akun Demo</p>
            <p className="text-sm mt-1">Email: <span className="mono font-bold">admin@pesanwa.id</span></p>
            <p className="text-sm">Password: <span className="mono font-bold">admin123</span></p>
            <button
              type="button"
              onClick={() => { setEmail("admin@pesanwa.id"); setPassword("admin123"); }}
              className="nb-btn nb-btn-secondary mt-2 text-xs !py-1 !px-3"
              data-testid="demo-fill-button"
            >
              Isi Otomatis
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
